import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'maximizer-warning',
    template: ` <div class="flex flex-col w-full">
    <div class="rounded-sm p-3 bg-yellow-5 w-full">
      @if (translationEntry()) {
        <p class="text-body">
          {{ translationEntry() | translate }}
        </p>
      }
      <ng-content></ng-content>
    </div>
  </div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe],
})
export class WarningComponent {
  translationEntry = input<string | undefined>(undefined);
}
